import './SeoBlock.css';

export function SeoBlock() {
  return (
    <section class="section section--tight seoblock">
      <div class="container">
        <div class="seoblock__inner" data-reveal>
          <h2 class="seoblock__title">
            Поставка двигателей и&nbsp;запчастей для&nbsp;спецтехники по&nbsp;России
          </h2>
          <div class="seoblock__cols">
            <p>
              Компания «Концепт 13» занимается продажей и поставкой двигателей, коробок передач, мостов и
              запчастей для грузовых автомобилей и спецтехники.
            </p>
            <p>
              Работаем с грузовой, строительной, карьерной, сельскохозяйственной и промышленной техникой российских,
              европейских, американских и азиатских производителей. Помогаем найти как распространённые агрегаты,
              так и редкие запчасти, отсутствующие у большинства российских продавцов.
            </p>
            <p>
              Подбираем комплектные двигатели и отдельные узлы по VIN-коду, серийному номеру, каталожному номеру
              или фотографии шильдика. Перед заказом уточняем состояние, комплектацию, совместимость и срок доставки.
            </p>
            <p>
              Организуем поставку по Екатеринбургу, Москве, Санкт-Петербургу, Новосибирску, Челябинску, Тюмени
              и другим городам России.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
